import React from "react";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const maxPagesToShow = 5;
  const halfPagesToShow = Math.floor(maxPagesToShow / 2);

  const getDisplayedPageNumbers = () => {
    let startPage = Math.max(1, currentPage - halfPagesToShow);
    let endPage = Math.min(totalPages, currentPage + halfPagesToShow);

    if (endPage - startPage + 1 < maxPagesToShow) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
      } else if (endPage === totalPages) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  };

  return (
    <nav className="flex justify-center items-center space-x-2 mt-2 mb-2 p-1">
      <button
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        className="px-4 py-2 text-12 border rounded-md text-gray-700 bg-white disabled:opacity-50 hover:bg-gray-100"
      >
        «
      </button>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-4 text-12 py-2 border rounded-md text-gray-700 bg-white disabled:opacity-50 hover:bg-gray-100"
      >
        ‹
      </button>
      {getDisplayedPageNumbers().map((number) => (
        <button
          key={number}
          onClick={() => onPageChange(number)}
          className={`px-4 py-2 border rounded-md text-12 ${currentPage === number ? "bg-gradient-to-r from-[#0E4C84] to-[#00A7C1] hover:from-[#135EA0] hover:to-[#00B8D4] text-white" : "text-gray-700 bg-white hover:bg-gray-100"}`}
        >
          {number}
        </button>
      ))}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-4 py-2 border text-12 rounded-md text-gray-700 bg-white disabled:opacity-50 hover:bg-gray-100"
      >
        ›
      </button>
      <button
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        className="px-4 py-2 border text-12 rounded-md text-gray-700 bg-white disabled:opacity-50 hover:bg-gray-100"
      >
        »
      </button>
    </nav>
  );
};

export default Pagination;
